
<div class="col-md-12">
    <div class="col-lg-12 nopadding">
      <app-filter-panel [GridColumns]="GridColumns" [DefaultFilterArray]="defaultFilterArray"
        (FilterEvent)="filterApplyFilterEvent($event)">
      </app-filter-panel>
    </div>
    <br/>
    <div class="col-lg-12 nopadding">
      <div class="ui-widget-header-1 nopadding">
        <div class="ui-grid-col-12 btnPanel">
          <label for="maxOrdQty">
            <button id="maxOrdQty" type="button" [disabled]="false" [ngClass]="(recordSummaryType === 1 ? 'optedBtnColor' : '')" (click)="getMarketAccessData(1, 'Maximum Quantity')" class="button btn-lg button-text innerScreenTabBtn panel-button">Maximum Order Quantity</button>
          </label>
          <label for="maxQtyNotional">
            <button id="maxQtyNotional" type="button" [disabled]="false" [ngClass]="(recordSummaryType === 2 ? 'optedBtnColor' : '')" (click)="getMarketAccessData(2, 'Maximum Notional')" class="button btn-lg custom-panel-button innerScreenTabBtn panel-button">Maximum Notional</button>
          </label>
          <label for="maxPriceDeviationNbbo">
            <button id="maxPriceDeviationNbbo" type="button" [disabled]="false"  [ngClass]="(recordSummaryType === 3 ? 'optedBtnColor' : '')" (click)="getMarketAccessData(3, 'Maximum Price Deviation')" class="button btn-lg button-text innerScreenTabBtn panel-button">Maximum % Price Deviation From NBBO</button>
          </label>
          <label for="maxOrderQtyAsOf30DayADV">
            <button id="maxOrderQtyAsOf30DayADV" type="button" [disabled]="false" [ngClass]="(recordSummaryType === 4 ? 'optedBtnColor' : '')" (click)="getMarketAccessData(4, 'Maximum Order Quantity of 30 Day ADV')" class="button btn-lg button-text innerScreenTabBtn panel-button">Maximum Order Quantity 30 Day ADV</button>
          </label>
          <label for="maxDailyGrossNotionalAmt">
            <button id="maxDailyGrossNotionalAmt" type="button" [disabled]="false" [ngClass]="(recordSummaryType === 5 ? 'optedBtnColor' : '')" (click)="getMarketAccessData(5, 'Maximum Gross Notional')" class="button btn-lg button-text innerScreenTabBtn panel-button">Maximum Daily Gross Notional</button>
          </label>
      </div>
    </div>
    <br/>
    <!-- Destination, Customer, Trader Details -->
      <div class="col-lg-12 nopadding" [ngClass]="(maxPriceDeviationTable || maxOrderQty30DayAdvTable || maxDailyGrossNotionalTable ? 'notdisplay': '')">
        @if(isLoadingDestinationResults){
        <div class="example-loading-shade">
          <mat-spinner diameter="40"></mat-spinner>
        </div>
        }
        <p-table class="destinationDetails" [columns]="optedDestinations" [value]="destinationDetail" [scrollable]="true"
        scrollHeight="200px" scrollDirection="both" frozenWidth="158px">
          <ng-template pTemplate="colgroup" let-columns>
            <colgroup>
              @for(col of columns; track col.field + '-'+ $index; let idx = $index) {
              <col class="cellHeight">
              }
            </colgroup>
          </ng-template>
          <ng-template pTemplate="header" let-columns>
            <tr>
              @for(col of frozenCols; track col.field + '-'+ $index; let idx = $index) {
              <th id="maxQtyDataHeader" style="background-color: #a8c4ec !important" class="table-frozen-column" pFrozenColumn>
                @if(maxQtyData.length===0){
                <span pFrozenColumn>{{col.header}}</span>
                }
                @if(maxQtyData.length>0){
                <span pFrozenColumn> 
                  <p-multiSelect appendTo="body" [options]="scrollableCols" [(ngModel)]="optedDestinations" (onChange)="getFilterData($event, col.field)" 
                  optionLabel="header" selectedItemsLabel="{0} Destinations" placeholder="Select Destination"></p-multiSelect>
                </span>
                }
              </th>
              }
              @for(col of columns; track col.header + '-'+ $index; let idx = $index) {
              <th id="columns">
                {{col.header.substring(col.header.indexOf(":")+1)}}
              </th>
              }
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-rowData let-columns="columns" let-rowIndex="rowIndex">
            <tr>
              @for(col of frozenCols; track col.field + '-'+ $index; let idx = $index) {
              <td pFrozenColumn style="z-index: 1" class="frozenColDetails" (click)="fieldSort(col.field, rowIndex);">
                {{rowData[col.field]}}
                @if(destinationSortField===rowIndex){
                <i [ngClass]="(destinationQtyFieldSortOrder==='asc' || destinationNotionalFieldSortOrder==='asc' ? 'ui-sortable-column-icon pi pi-fw pi-sort-up' : 'ui-sortable-column-icon pi pi-fw pi-sort-down')"></i>
                }
              </td>
              }
              @for(col of columns; track col.field + '-'+ $index; let idx = $index) {
              <td class="colDetails" (click)="onRowActionSelect('View', 'Destination', rowIndex, col.header)">
                {{rowData[col.field]}}
              </td>
              }
            </tr>
          </ng-template>
        </p-table>
        <br/>
      </div>
      <div class="col-lg-12 nopadding" [ngClass]="(maxPriceDeviationTable || maxOrderQty30DayAdvTable || maxDailyGrossNotionalTable ? 'notdisplay': '')">
        @if(isLoadingCustomerResults){
        <div class="example-loading-shade">
          <mat-spinner diameter="40"></mat-spinner>
        </div>
        }
        <p-table class="customerDetails" [columns]="optedCustomers" [value]="customerDetail" [scrollable]="true"
          scrollHeight="200px" scrollDirection="both" frozenWidth="158px">
          <ng-template pTemplate="colgroup" let-columns>
            <colgroup>
              @for(col of columns; track col.field + '-'+ $index; let idx = $index) {
              <col class="cellHeight">
              }
            </colgroup>
          </ng-template>
          <ng-template pTemplate="header" let-columns>
            <tr>
              @for(col of frozenCustomerCols; track col.field + '-'+ $index; let idx = $index) {
              <th id="frozenCustomerColsHeader" style="background-color: #a8c4ec !important" class="table-frozen-column" pFrozenColumn>
                @if(customerMaxQtyData.length===0){
                <span pFrozenColumn>{{col.header}}</span>
                }
                @if(customerMaxQtyData.length>0){
                <span pFrozenColumn> 
                  <p-multiSelect appendTo="body" [options]="scrollableCustomerCols" [(ngModel)]="optedCustomers" (onChange)="getFilterData($event, col.field)" 
                  optionLabel="header" selectedItemsLabel="{0} Customers" placeholder="Select Customer"></p-multiSelect>
                </span>
                }
              </th>
              }
              @for(col of columns; track col.header + '-'+ $index; let idx = $index) {
              <th id="colHeader">
                {{col.header.substring(col.header.indexOf(":")+1)}}
              </th>
              }
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-rowData let-columns="columns" let-rowIndex="rowIndex">
            <tr>
              @for(col of frozenCustomerCols; track col.field + '-'+ $index; let idx = $index) {
              <td pFrozenColumn style="z-index: 1" class="frozenColDetails" (click)="fieldSort(col.field, rowIndex);">
                {{rowData[col.field]}}
                @if(customerSortField===rowIndex){
                <i [ngClass]="(customerQtyFieldSortOrder==='asc' || customerNotionalFieldSortOrder==='asc' ? 'ui-sortable-column-icon pi pi-fw pi-sort-up' : 'ui-sortable-column-icon pi pi-fw pi-sort-down')"></i>
                }
              </td>
              }
              @for(col of columns; track col.field + '-'+ $index; let idx = $index) {
              <td class="colDetails" (click)="onRowActionSelect('View', 'Customer', rowIndex, col.header);">
                {{rowData[col.field]}}
              </td>
              }
            </tr>
          </ng-template>
        </p-table>
        <br/>
      </div>
      <div class="col-lg-12 nopadding" [ngClass]="(maxPriceDeviationTable || maxOrderQty30DayAdvTable || maxDailyGrossNotionalTable ? 'notdisplay': '')">
        @if(isLoadingTraderResults){
        <div class="example-loading-shade">
          <mat-spinner diameter="40"></mat-spinner>
        </div>
        }
        <p-table class="traderDetails" [columns]="optedTraders" [value]="traderDetail" [scrollable]="true"
          scrollHeight="200px" scrollDirection="both" frozenWidth="158px">
          <ng-template pTemplate="colgroup" let-columns>
            <colgroup>
              @for(col of columns; track col.header + '-'+ $index; let idx = $index) {
              <col [ngClass]="(col.field==='Trader' ? 'cellHeight' : 'cellMaxHeight')">
              }
            </colgroup>
          </ng-template>
          <ng-template pTemplate="header" let-columns>
            <tr>
              @for(col of frozenTraderCols; track col.field + '-'+ $index; let idx = $index) {
              <th id="traderMaxQtyDataHeader" class="cellHeight" style="background-color: #a8c4ec !important" class="trader-frozen-column" pFrozenColumn>
                @if(traderMaxQtyData.length===0){
                <span pFrozenColumn>{{col.header}}</span>
                }
                @if(traderMaxQtyData.length>0){
                <span pFrozenColumn> 
                  <p-multiSelect appendTo="body" [options]="scrollableTraderCols" [(ngModel)]="optedTraders" (onChange)="getFilterData($event, col.field)" 
                  optionLabel="header" selectedItemsLabel="{0} Traders" placeholder="Select Trader"></p-multiSelect>
                </span>
                }
              </th>
              }
              @for(col of columns; track col.header + '-'+ $index; let idx = $index) {
              <th id="colHeader" class="cellMaxHeight">
                {{col.header.substring(col.header.indexOf(":")+1)}}
              </th>
              }
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-rowData let-columns="columns" let-rowIndex="rowIndex">
            <tr>
              @for(col of frozenTraderCols; track col.field + '-'+ $index; let idx = $index) {
              <td pFrozenColumn style="z-index: 1" class="frozenColDetails" (click)="fieldSort(col.field, rowIndex);">
                {{rowData[col.field]}}
                @if(traderSortField===rowIndex){
                <i [ngClass]="(traderQtyFieldSortOrder==='asc' || traderNotionalFieldSortOrder==='asc' ? 'ui-sortable-column-icon pi pi-fw pi-sort-up' : 'ui-sortable-column-icon pi pi-fw pi-sort-down')"></i>
                }
              </td>
              }
              @for(col of columns; track col.field + '-'+ $index; let idx = $index) {
              <td class="colDetails" (click)="onRowActionSelect('View', 'Trader', rowIndex, col.header);">
                {{rowData[col.field]}}
              </td>
              }
            </tr>
          </ng-template>
        </p-table>
        <br/>
      </div>
    <!-- End of Destination, Customer, Trader Details -->
    <!-- Price Deviation -->
      <div class="col-lg-12 nopadding" [ngClass]="(!maxPriceDeviationTable ? 'notdisplay': '')">
        @if(isLoadingPriceDeviationResults){
        <div class="example-loading-shade">
          <mat-spinner diameter="40"></mat-spinner>
        </div>
        }
        <p-table class="priceDeviationDetails" [columns]="scrollablePriceDeviationCols" [value]="priceDeviationDetail" [scrollable]="true"
        styleClass="prime-table-price-deviation" scrollHeight="200px" scrollDirection="both" frozenWidth="280px">
          <ng-template pTemplate="colgroup" let-columns>
            <colgroup>
              @for(col of columns; track col.header + '-'+ $index; let idx = $index) {
              <col class="cellMaxHeight" style="width:140px;">
              }
            </colgroup>
          </ng-template>
          <!-- Price Deviation Header -->
          <ng-template pTemplate="header" let-columns>
            <tr>
              <th id="columnHeader" pFrozenColumn style="background-color: #a8c4ec !important"></th>
              @for(col of columns; track col.header + '-'+ $index; let idx = $index) {
              <th id="colHeader" style="background-color: #a8c4ec !important"></th>
              }
            </tr>
          </ng-template>
          <!-- End of Price Deviation Header -->
          <ng-template pTemplate="body" let-rowData let-columns="columns" let-rowIndex="rowIndex">
            <tr>
              @for(col of frozenPriceDeviationCols; track col.field + '-'+ $index; let idx = $index) {
              <td pFrozenColumn style="z-index: 1" class="frozenColDetails" (click)="fieldSort('Price_Deviation', rowIndex);">
                {{rowData[col.field]}}
                @if((priceDeviationSortField===rowIndex && (rowData[col.field]==='Route' || rowData[col.field]==='Order'))){
                  <i [ngClass]="(routeBuyFieldSortOrder==='asc' || routeSellFieldSortOrder==='asc' || orderBuyFieldSortOrder==='asc' || orderSellFieldSortOrder==='asc' ? 'ui-sortable-column-icon pi pi-fw pi-sort-up' : 'ui-sortable-column-icon pi pi-fw pi-sort-down')"></i>
                  }
              </td>
              }
              @for(col of columns; track col.field + '-'+ $index; let idx = $index) {
              <td class="colDetails" (click)="onRowActionSelect('View', 'Price Deviation', rowIndex, col.header);">
                {{rowData[col.field]}}
              </td>
              }
            </tr>
          </ng-template>
        </p-table>
        <br/>
      </div>
    <!-- End of Price Deviation -->
    <!-- Maximum Order Quantity of 30 Day ADV -->
    <div class="col-lg-12 nopadding" [ngClass]="(!maxOrderQty30DayAdvTable ? 'notdisplay': '')">
      @if(isLoadingMaxOrderQty30DayAdvResults){
      <div class="example-loading-shade">
        <mat-spinner diameter="20"></mat-spinner>
      </div>
      }
      <p-table class="symbolDetails" [columns]="scrollableMaxOrderSymbolQtyCols" [value]="maxSymbolOrderQtyDetail" [scrollable]="true"
      scrollHeight="200px" scrollDirection="both" frozenWidth="136px">
        <ng-template pTemplate="colgroup" let-columns>
          <colgroup>
        @for(col of columns; track col.header + '-'+ $index; let idx = $index) {
        <col class="cellHeight" style="width:139px;">
        }
          </colgroup>
        </ng-template>
        <ng-template pTemplate="header" let-columns>
          <tr>
        @for(col of frozenMaxOrderSymbolQtyCols; track col.field + '-'+ $index; let idx = $index) {
        <th id="colHeader" style="background-color: #a8c4ec !important" class="order-qty-table-frozen-column" pFrozenColumn>
          {{col.header}}
        </th>
        }
        @for(col of columns; track col.header + '-'+ $index; let idx = $index) {
        <th id="orderQtyHeader" class="order-qty-table-column">
          {{col.header.substring(col.header.indexOf(":")+1)}}
        </th>
        }
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData let-columns="columns" let-rowIndex="rowIndex">
          <tr>
        @for(col of frozenMaxOrderSymbolQtyCols; track col.field + '-'+ $index; let idx = $index) {
        <td pFrozenColumn style="z-index: 1" class="frozenColDetails" (click)="fieldSort(col.field, rowIndex);">
          {{rowData[col.field]}}
          <i [ngClass]="(maxOrderQtyFieldSortOrder==='asc' ? 'ui-sortable-column-icon pi pi-fw pi-sort-up' : 'ui-sortable-column-icon pi pi-fw pi-sort-down')"></i>
        </td>
        }
        @for(col of columns; track col.field + '-'+ $index; let idx = $index) {
        <td class="colDetails">
          {{rowData[col.field]}}
        </td>
        }
          </tr>
        </ng-template>
      </p-table>
      <br/>
    </div>
    <!-- End of Maximum Order Quantity of 30 Day ADV -->
    <!-- Maximum Daily Gross Notional -->
      <div class="col-lg-12 nopadding" [ngClass]="(!maxDailyGrossNotionalTable ? 'notdisplay': '')">
        @if(isLoadingGrossNotionalResults){
        <div class="example-loading-shade">
          <mat-spinner diameter="40"></mat-spinner>
        </div>
        }
        <p-table class="notionalDetails" [columns]="scrollableNotionalCols" [value]="grossNotionalDetail" [scrollable]="true"
        scrollHeight="200px" scrollDirection="both" frozenWidth="140px">
          <ng-template pTemplate="colgroup" let-columns>
            <colgroup>
              @for(col of columns; track col.field + '-'+ $index; let idx = $index) {
              <col class="cellMaxHeight" style="width:140px;">
              }
            </colgroup>
          </ng-template>
          <ng-template pTemplate="header" let-columns>
            <tr>
              @for(col of frozenNotionalCols; track col.field + '-'+ $index; let idx = $index) {
              <th id="colHeader" class="cellMaxHeight" style="background-color: #a8c4ec !important" pFrozenColumn>
                {{col.header}}
              </th>
              }
              @for(col of columns; track col.header + '-'+ $index; let idx = $index) {
              <th id="colHeader" class="cellMaxHeight">
                {{col.header.substring(col.header.indexOf(":")+1)}}
              </th>
              }
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-rowData let-columns="columns" let-rowIndex="rowIndex">
            <tr>
              @for(col of frozenNotionalCols; track col.field + '-'+ $index; let idx = $index) {
              <td pFrozenColumn style="z-index: 1" class="frozenColDetails" (click)="fieldSort(col.field, rowIndex);">
                {{rowData[col.field]}}
                @if(notionalSortField===rowIndex){
                <i [ngClass]="(notionalBuyOpenFieldSortOrder==='asc' || notionalSellOpenFieldSortOrder==='asc' || notionalBuyExecutedFieldSortOrder==='asc' || notionalSellExecutedFieldSortOrder==='asc' ? 'ui-sortable-column-icon pi pi-fw pi-sort-up' : 'ui-sortable-column-icon pi pi-fw pi-sort-down')"></i>
                }
              </td>
              }
              @for(col of columns; track col.field + '-'+ $index; let idx = $index) {
              <td class="colDetails">
                {{rowData[col.field]}}
              </td>
              }
            </tr>
          </ng-template>
        </p-table>
        <br/>
      </div>
    <!-- End of Max Daily Gross Notional -->
    <!-- Summary Table Details -->
    <div class="col-lg-12 nopadding" [ngClass]="(maxOrderQty30DayAdvTable || maxDailyGrossNotionalTable ? 'notdisplay': '')">
      @if(isLoadingResults){
      <div class="example-loading-shade">
        <mat-spinner></mat-spinner>
      </div>
      }
      <p-table #dt 
        [value]="dataset" 
        [columns]="cols" 
        [resizableColumns]="true" 
        [lazy]="true" 
        (onPage)="changePage($event)"
        [sortOrder]="constantService.DEFAULT_SORDORDER_ASC" 
        [(selection)]="selectedRow"
        [paginator]="true"
        selectionMode="single"
        appendTo="body" 
        alwaysShowPaginator="true" 
        paginatorPosition="both"
        showCurrentPageReport="true" 
        [rows]="constantService.DEFAULT_ROWSIZE" 
        [totalRecords]="totalRecords"
        [pageLinks]="constantService.DEFAULT_PAGELINKS" 
        sortMode="multiple"
        (onSort)="sort($event)"
        [rowsPerPageOptions]="constantService.DEFAULT_ROWSPERPAGEOPTION">
        <ng-template pTemplate="emptymessage" let-columns>
          <tr>
            <td [attr.colspan]="columns.length">
              {{constantService.NO_RECORDFOUND_MSG}}
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="header" let-columns let-rowIndex=rowIndex>
          <tr>
            @for(col of columns; track col.field + '-'+ $index; let idx = $index) {
            <th id="columnsHeader" pResizableColumn [pSortableColumn]="col.field"
              [ngClass]="(col?.display | lowercase) == 'false' ? 'notdisplay':'' ">
              {{col.header}}
              <p-sortIcon [field]="col.field"></p-sortIcon>
            </th>
            }
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row let-columns="columns" let-rowIndex="rowIndex">
          <tr [pSelectableRow]="row" [pSelectableRowIndex]="rowIndex" class="ui-widget-NoUpdated-row">
            @for(col of columns; track col.header + '-'+ $index; let idx = $index) {
            <td class="ui-resizable-column"
            [ngClass]="((col?.display | lowercase) == 'false' ? 'notdisplay':((col.header | lowercase) =='order id' ? 'orderColDetail' : ''))">
              <!-- set String -->
               @if(col.field === 'orderID'){
                <span>
                  <a matTooltip="View Order Details" [matTooltipShowDelay]="1000" appendTo="body" (click)="onShowOrderViewer(row, rowIndex);">{{row[col.field]}}</a>
                </span>
                }
                @if(col.field !== 'orderID'){
                <span [ngClass]="col.datatype === 'Int'? 'float-right' : ''">
                  {{row[col.field] !== 'null' ? row[col.field]: ""}}
                </span>
                }
            </td>
            }
          </tr>
        </ng-template>
        <ng-template pTemplate="paginatorright">
            <app-export-to-csv [gridColumns]="GridColumns" (exportToCSVListner)="exportToCSV($event)"></app-export-to-csv>
          Total Records: {{dataset.length == 0? 0 : totalRecords}}
    
        </ng-template>
        <ng-template pTemplate="paginatorleft">
          <!-- Page No : {{pageNumber }} -->
          Showing {{dataset.length == 0? 0 : startLimit + 1}} to {{dataset.length
             < rowcount ? dataset.length < startLimit ? endLimit : dataset.length : endLimit}} entries
        </ng-template>
      </p-table>
    </div>
  </div>
  <!-- End of Summary Table Details -->
<!-- Quick View Panel Code  -->
<p-drawer styleClass="u ui-sidebar-lg"
  [style]="{'width':'auto','max-width': '500px','height':'auto','overflow-y': 'auto','max-height':'100%'}"
  [(visible)]="view" position="right" [baseZIndex]="10000">
  <div class="ui-grid ui-grid-responsive ui-fluid">
    @for(ViewRow of cols; track ViewRow.label + '-'+ $index; let idx = $index) {
    <div class=" ui-grid-col-12">
      @if(ViewRow && ViewRow.label!='Type' && rowDataforDialog){
      <div>
        <span>
          <div class="ui-grid-col-4 quick-view-grid-row-hg">
            <label for="ViewRow">{{ViewRow.label}}</label>
          </div>
          <div lass="ui-grid-col-8 quick-view-grid-row">
            @if((ViewRow?.datatype | lowercase)!=='boolean'){
            <input [disabled]="true" pInputText [(ngModel)]="rowDataforDialog[0][ViewRow.value]" style="width:65%" />
          }
          @if((ViewRow?.datatype | lowercase)=='boolean'){
          <input [disabled]="true" pInputText value="{{rowDataforDialog[0][ViewRow.value] === '1' || rowDataforDialog[ViewRow.value] === true ? 'True': 'False'}}" style="width:65%">
          }
          </div>
        </span>
      </div>
    }
    </div>
  }
  </div>
</p-drawer>